import React, { useEffect, useState } from "react";
import Swal from "sweetalert2"; // Ensure this is installed via npm install sweetalert2
import { useFormik } from "formik";
import * as Yup from "yup";
import "./ContactPage.css";
import { API_URL } from "../../global";






const STATES_URL =
  'https://gist.githubusercontent.com/nateshmbhat/7e1a28eba37364be1456f9c4688bd2a7/raw/All%20States%20and%20Districts.json';

const fallbackMap = {
  'Andhra Pradesh': [
    'Anantapur',
    'Chittoor',
    'East Godavari',
    'Guntur',
    'Krishna',
    'Kurnool',
    'Prakasam',
    'Srikakulam',
    'Visakhapatnam',
    'Vizianagaram',
    'West Godavari',
  ],
  Karnataka: [
    'Bagalkot',
    'Ballari',
    'Belagavi',
    'Bengaluru Rural',
    'Bengaluru Urban',
    'Bidar',
    'Chamarajanagar',
    'Chikballapur',
    'Chikkamagaluru',
    'Chitradurga',
    'Dakshina Kannada',
    'Davanagere',
    'Dharwad',
    'Gadag',
    'Hassan',
    'Haveri',
    'Kalaburagi',
    'Kodagu',
    'Kolar',
    'Koppal',
    'Mandya',
    'Mysuru',
    'Raichur',
    'Ramanagara',
    'Shivamogga',
    'Tumakuru',
    'Udupi',
    'Uttara Kannada',
    'Vijayanagara',
    'Yadgir',
  ],
  'Tamil Nadu': [
    'Ariyalur',
    'Chengalpattu',
    'Chennai',
    'Coimbatore',
    'Cuddalore',
    'Dharmapuri',
    'Dindigul',
    'Erode',
    'Kallakurichi',
    'Kanchipuram',
    'Kanyakumari',
    'Karur',
    'Krishnagiri',
    'Madurai',
    'Mayiladuthurai',
    'Nagapattinam',
    'Namakkal',
    'Nilgiris',
    'Perambalur',
    'Pudukkottai',
    'Ramanathapuram',
    'Ranipet',
    'Salem',
    'Sivaganga',
    'Tenkasi',
    'Thanjavur',
    'Theni',
    'Thoothukudi',
    'Tiruchirappalli',
    'Tirunelveli',
    'Tirupattur',
    'Tiruppur',
    'Tiruvallur',
    'Tiruvannamalai',
    'Tiruvarur',
    'Vellore',
    'Viluppuram',
    'Virudhunagar',
  ],
};




const ContactPage = () => {


    const [stateDistrictMap, setStateDistrictMap] = useState(fallbackMap);
  const [districtOptions, setDistrictOptions] = useState(
    fallbackMap[Object.keys(fallbackMap)[0]] || []
  );
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionStatus, setSubmissionStatus] = useState('');

  /* ---------- LOAD STATE‒DISTRICT DATA (runs once) ---------- */
  useEffect(() => {
    fetch(STATES_URL)
      .then((res) => res.json())
      .then((data) => setStateDistrictMap(data))
      .catch(() => {
        /* fetch might fail because of CORS; fallbackMap already set */
      });
  }, []);





  /* ---------- FORMIK ---------- */
  const formik = useFormik({
    enableReinitialize: true,
initialValues: {
  username: '',   // <-- was name
  email: '',
  phone: '',
  subject: '',
  message: '',
  state: '',
  district: '',
},
    validationSchema: Yup.object({
      username: Yup.string()
        .max(50, 'Must be 50 characters or less')
        .required('Required'),
      email: Yup.string().email('Invalid email address').required('Required'),
      phone: Yup.string()
        .matches(/^[0-9]{10}$/, 'Phone number must be 10 digits')
        .required('Required'),
      subject: Yup.string()
        .max(100, 'Must be 100 characters or less')
        .required('Required'),
      message: Yup.string()
        .max(500, 'Must be 500 characters or less')
        .required('Required'),
      state: Yup.string().required('Required'),
      district: Yup.string().required('Required'),
    }),

    onSubmit: async (values) => {
      setIsSubmitting(true);
      setSubmissionStatus('');
      try {
          const response = await fetch(`${API_URL}/contact`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(values),
        });
        if (response.ok) {
          setSubmissionStatus('Form submitted successfully!');
          formik.resetForm();
        } else {
          setSubmissionStatus('Failed to submit the form. Please try again.');
        }
      } catch (error) {
        setSubmissionStatus('An error occurred. Please try again.');
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  /* ---------- HANDLE STATE CHANGE ---------- */
  const handleStateChange = (e) => {
    const selected = e.target.value;
    formik.setFieldValue('state', selected);
    formik.setFieldValue('district', '');
    const districts = stateDistrictMap[selected] || [];
    setDistrictOptions(districts);
  };
  
  
  useEffect(() => {
    const body = document.querySelector('#root'); 
      body.scrollIntoView({
          behavior: 'smooth'
      }, 500)
    
    }, []);






  return (
    <div style={{ marginTop: "70px" }}>
      {/* Header Image */}
      <img className="ContactFirst-image" src="https://res.cloudinary.com/dmv2tjzo7/image/upload/v1732884483/whfyv7etmogwfir4krmt.png" alt="Contact" />

      {/* Contact Form Section */}
      <div className="contactpage-container">
        <div className="row mt-3">
          {/* Form Section */}
          <div className="col-lg-6 col-md-8 col-sm-12 mx-auto mt-4">
            <h3 className="animate-title text-center">Contact Form</h3>
           <form onSubmit={formik.handleSubmit} className=" form-page">
              {/* Name */}
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="username"
                  name="username"
                  className={`form-control ${formik.touched.username && formik.errors.username ? "is-invalid" : ""
                    }`}
                  value={formik.values.username}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.username && formik.errors.username && (
                  <div className="invalid-feedback">{formik.errors.username}</div>
                )}
              </div>

              {/* Email */}
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className={`form-control ${formik.touched.email && formik.errors.email ? "is-invalid" : ""
                    }`}
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email && (
                  <div className="invalid-feedback">{formik.errors.email}</div>
                )}
              </div>

              {/* Phone */}
              <div className="form-group">
                <label htmlFor="phone">Phone</label>
                <input
                  type="text"
                  id="phone"
                  name="phone"
                  className={`form-control ${formik.touched.phone && formik.errors.phone ? "is-invalid" : ""
                    }`}
                  value={formik.values.phone}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.phone && formik.errors.phone && (
                  <div className="invalid-feedback">{formik.errors.phone}</div>
                )}
              </div>

              {/* Subject */}
              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  className={`form-control ${formik.touched.subject && formik.errors.subject ? "is-invalid" : ""
                    }`}
                  value={formik.values.subject}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.subject && formik.errors.subject && (
                  <div className="invalid-feedback">{formik.errors.subject}</div>
                )}
              </div>

              {/* Message */}
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  rows="2"
                  className={`form-control ${formik.touched.message && formik.errors.message ? "is-invalid" : ""
                    }`}
                  value={formik.values.message}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                ></textarea>
                {formik.touched.message && formik.errors.message && (
                  <div className="invalid-feedback">{formik.errors.message}</div>
                )}
              </div>

              {/* State */}
              <div className="form-group">
                <label htmlFor="state">State</label>
                <select
                  id="state"
                  name="state"
                  className={`form-control ${formik.touched.state && formik.errors.state ? "is-invalid" : ""
                    }`}
                  value={formik.values.state}
                  onChange={handleStateChange}
                  onBlur={formik.handleBlur}
                >
                  <option value="">-- Select State --</option>
                  {Object.keys(stateDistrictMap).map((state) => (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  ))}
                </select>
                {formik.touched.state && formik.errors.state && (
                  <div className="invalid-feedback">{formik.errors.state}</div>
                )}
              </div>

              {/* District */}
              <div className="form-group">
                <label htmlFor="district">District</label>
                <select
                  id="district"
                  name="district"
                  className={`form-control ${formik.touched.district && formik.errors.district ? "is-invalid" : ""
                    }`}
                  value={formik.values.district}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value="">-- Select District --</option>
                  {districtOptions.map((district) => (
                    <option key={district} value={district}>
                      {district}
                    </option>
                  ))}
                </select>
                {formik.touched.district && formik.errors.district && (
                  <div className="invalid-feedback">{formik.errors.district}</div>
                )}
              </div>

              {/* Submit */}
              <button type="submit" className="btn btn-primary w-100" disabled={isSubmitting}>
                {isSubmitting ? "Submitting..." : "Submit"}
              </button>
              {submissionStatus && (
                <div className="text-center mt-2">{submissionStatus}</div>
              )}
            </form>
          </div>


          {/* Address Section */}
          <div className="col-lg-6 second-column">
            <h2 className="addressinfo">Address Information</h2>
            <div className="addressPage">
              <div className="addresscontent">
                <p>Polyhose Tower No.86, West Wing, 4th Floor</p>
                <p>Anna Salai, Guindy, Chennai, Tamil Nadu-600032</p>
                <br />
                <p className="contact-paratag">
                  Website:{" "}
                  <a
                    href="https://shop.zuppa.io/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Shop.zuppa.io
                  </a>
                </p>
                <p className="contact-paratag">
                  Email:{" "}
                  <a
                    href="mailto:askme@zuppa.io"
                    target="_blank"
                    rel="noreferrer"
                  >
                    askme@zuppa.io
                  </a>
                </p>
                <p className="contact-paratag">
                  Ph. No:{" "}
                  <a href="tel:9952081655" target="_blank" rel="noreferrer">
                    +91 9952081655
                  </a>
                </p>
                <p className="contact-paratag">
                  LinkedIn:{" "}
                  <a
                    href="https://www.linkedin.com/company/zuppa-drones/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Zuppa LinkedIn
                  </a>
                </p>
                <p className="contact-paratag">
                  Twitter:{" "}
                  <a
                    href="https://x.com/ZuppaGeoNavTech"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Zuppa Twitter
                  </a>
                </p>
                <p className="contact-paratag">
                  Facebook:{" "}
                  <a
                    href="https://www.facebook.com/share/FdfjhFAxGpWufN1p/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Zuppa Facebook
                  </a>
                </p>
                <p className="contact-paratag">
                  Instagram:{" "}
                  <a
                    href="https://www.instagram.com/zuppageonav/profilecard/?igsh=MWQybWdteHk1azV5eA=="
                    target="_blank"
                    rel="noreferrer"
                  >
                    Zuppa Instagram
                  </a>
                </p>
                <p className="contact-paratag">
                  Location:{" "}
                  <a
                    href="https://www.google.com/maps/place/Zuppa+Geo+Navigation+Technologies+Private+Limited/@13.0118583,80.2156106,17z/data=!3m1!4b1!4m6!3m5!1s0x3a52678d4cde040b:0xd60e2a228e4ee474!8m2!3d13.0118531!4d80.2181855!16s%2Fg%2F11ft4d2svk?entry=tts"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Zuppa Location
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
